'use client'

import { twMerge } from '@/lib/classname/twMerge'
import type { IconProps } from '@/ui/icons/icon/Icon'
import { Loader } from '@/ui/loaders/loader/Loader'
import { cloneElement } from 'react'

type ButtonContentProps = {
  children: string
  iconLeft?: React.ReactElement<IconProps>
  iconRight?: React.ReactElement<IconProps>
  isLoading?: boolean
  isRound?: boolean
  isLinkTone?: boolean
  bold?: boolean
}

export function ButtonContent({
  children,
  iconLeft,
  iconRight,
  isLoading = false,
  isRound = false,
  isLinkTone = false,
  bold = false,
}: ButtonContentProps) {
  return (
    <>
      <span className={twMerge('btn-text', isLinkTone && 'font-medium', bold && 'font-bold')}>
        {children}
      </span>
      {iconLeft &&
        cloneElement(iconLeft, {
          className: twMerge('btn-icon btn-icon-left relative', iconLeft.props.className),
        })}
      {!isRound &&
        iconRight &&
        cloneElement(iconRight, {
          className: twMerge('btn-icon btn-icon-right relative', iconRight.props.className),
        })}
      {isLoading && <Loader className="btn-loader" />}
    </>
  )
}
